import script from "./SearchReleaseDateFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchReleaseDateFilter.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__